import { render, staticRenderFns } from "./KeywordDetail.vue?vue&type=template&id=0ccf7125&scoped=true"
import script from "./KeywordDetail.vue?vue&type=script&lang=js"
export * from "./KeywordDetail.vue?vue&type=script&lang=js"
import style0 from "./KeywordDetail.vue?vue&type=style&index=0&id=0ccf7125&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccf7125",
  null
  
)

export default component.exports